import { MfaValue } from '../../../api/configurations/mfa';
import { validateUrlLink } from '../../../utils';

type MfaForm = MfaValue & {
  mfa_toggle: boolean;
};

type CallbackURLValidate = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export const mfaUrlValidation = (values: MfaForm): CallbackURLValidate => {
  const error: CallbackURLValidate = {
    mfa_url: undefined
  };

  if (!validateUrlLink(values.mfa_url || '')) {
    error.mfa_url = 'app.validation.url-invalid';
  }

  return error;
};
